/**
 * Copyright 2019 xdot GmbH
 * Author: Carsten Bühler
 * Date: 07.02.2019
 *
 */
'use strict';

import React from 'external/react';
import PropTypes from 'external/prop-types';
import {
    AppContext,
    DataLinkContainer,
    debounce,
    ScrollableDataListRV,
    translation
} from 'plugin/liferay-widgets-react-web';
import { Col, Container, FormControl, Row } from 'external/react-bootstrap';
import { MapLinkListItem } from 'plugin/map-portlet';

class BusinessObjectMultiSelect extends React.Component {

    constructor(props){
        super(props);

        this.DATA = {
            FLIWAS_OBJECT_ALL_LIST: this.withCtx('FLIWAS_OBJECT_ALL_LIST'),
            FLIWAS_OBJECT_ACTIVE_LIST: this.withCtx('FLIWAS_OBJECT_ACTIVE_LIST')
        };

        this.state = {
            searchValue: ''
        };

        this.AllListCHOC = DataLinkContainer.link(ScrollableDataListRV, ['list'], this.props.store);
        this.ActiveListCHOC = DataLinkContainer.link(ScrollableDataListRV, ['list'], this.props.store);
        this.searchList = debounce(this.searchList.bind(this), 300);
    }

    componentDidMount(){
        this.searchList('');
        this.listActive(this.props.formData && this.props.formData[this.props.propName]);
    }

    withCtx(s){
        return this.props.formId + '.' + s;
    }

    searchList(searchValue){
        this.props.onSearch(this.DATA.FLIWAS_OBJECT_ALL_LIST, {
            start: 0,
            end: AppContext.DEFAULT_LIST_SIZE,
            searchValue: searchValue || ''
        });
    }

    listActive(activeIds){
        this.props.onListActive(this.DATA.FLIWAS_OBJECT_ACTIVE_LIST, {
            start: 0,
            end: AppContext.DEFAULT_LIST_SIZE,
            activeIds: activeIds || ''
        });
    }

    setActive(item){
        const activeItemIds = this.getActiveOrganizationIdsFromFormData();
        const idx = activeItemIds.findIndex(id => item[this.props.idPropName] === id);
        let newActiveItemIds = [...activeItemIds];
        if (idx === -1) {
            newActiveItemIds.push(item[this.props.idPropName]);
        } else {
            newActiveItemIds.splice(idx, 1);
        }

        this.props.onChange({
            ...this.props.formData,
            [this.props.propName]: newActiveItemIds
        });
        this.listActive(newActiveItemIds);
    }

    getActiveOrganizationIdsFromFormData(){
        let activeItemIds = this.props.formData[this.props.propName];
        if (typeof activeItemIds == 'string') {
            activeItemIds = JSON.parse(activeItemIds);
        }
        if (!activeItemIds) {
            activeItemIds = [];
        }
        return activeItemIds;
    }

    deleteSelected(deleteId){
        this.props.onChange({
            ...this.props.formData,
            [this.props.propName]: this.getActiveOrganizationIdsFromFormData().filter(id => deleteId !== id)
        });
    }

    updateSearchValue(e){
        this.setState({ searchValue: e.target.value });
        this.searchList(e.target.value);
    }

    more(query){
        this.props.onMore(this.DATA.FLIWAS_OBJECT_ALL_LIST, query);
    }

    render(){
        const { searchValue } = this.state;
        const { selectedListTitle } = this.props;
        const activeOrganizationIds = this.getActiveOrganizationIdsFromFormData();

        return (
            <Container className="py-3">
                <Row noGutters>
                    <Col xs={12} sm={12} md={6} className="col-left">
                        <FormControl
                            className="mb-3"
                            type="text"
                            value={searchValue}
                            placeholder="Nach Namen suchen"
                            onChange={this.updateSearchValue.bind(this)}
                        />
                        <this.AllListCHOC
                            className="fliwas-organizations-config-list"
                            list={this.DATA.FLIWAS_OBJECT_ALL_LIST}
                            size="medium"
                            ListItem={this.props.CustomAllListMapLinkListItem || MapLinkListItem}
                            propName={this.props.idPropName}
                            onClick={i => this.setActive(i)}
                            activeIds={activeOrganizationIds}
                            onClickMore={this.more.bind(this)}
                        />
                    </Col>
                    <Col xs={12} sm={12} md={6} className="col-right nopadding nomargin">
                        <h3 className="mb-3 pl-3">
                            {
                                selectedListTitle ? selectedListTitle : ('Aktive ' + translation.trans(this.props.className))
                            }
                        </h3>

                        <this.ActiveListCHOC
                            className="fliwas-organizations-config-list pl-3"
                            list={this.DATA.FLIWAS_OBJECT_ACTIVE_LIST}
                            size="medium"
                            ListItem={this.props.CustomActiveListMapLinkListItem || MapLinkListItem}
                            propName={this.props.idPropName}
                            onClick={i => this.setActive(i)}
                            activeIds={activeOrganizationIds}
                            onClickMore={this.more.bind(this)}
                        />
                    </Col>
                </Row>
            </Container>
        );
    }
}

BusinessObjectMultiSelect.propTypes = {
    onChange: PropTypes.func.isRequired,
    formId: PropTypes.string.isRequired,
    formData: PropTypes.object,

    className: PropTypes.string.isRequired,
    idPropName: PropTypes.string,
    selectedListTitle: PropTypes.string,
    propName: PropTypes.string.isRequired,
    onMore: PropTypes.func.isRequired,
    onSearch: PropTypes.func.isRequired,
    onListActive: PropTypes.func.isRequired,
    store: PropTypes.object.isRequired,
    CustomActiveListMapLinkListItem: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.func
    ]),
    CustomAllListMapLinkListItem: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.func
    ])
};

BusinessObjectMultiSelect.defaultProps = {
    idPropName: 'id'
};

export default BusinessObjectMultiSelect;




// WEBPACK FOOTER //
// ./js/components/BusinessObjectMultiSelect.jsx